// extracted by mini-css-extract-plugin
module.exports = {"root":"WaitListUserButton_root__lK1CF"};